// Mock data — reemplazar con datos reales de Tokko cuando haya API key
import { TOKKO_TYPE_MAP, TOKKO_OP_MAP } from '../data/constants.js';

const img = (id, w = 900) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;
const photos = (ids) => ids.map(id => ({ image: img(id), thumb: img(id, 360) }));

export const MOCK_PROPERTIES = [
  {
    id: 'p01', reference_code: 'AB-2041', web_price: true,
    title: 'Urban VII · 2 ambientes a estrenar con balcón al río',
    slug: 'urban-vii-2amb-don-bosco-10',
    operations: [{ operation_type: '1', prices: [{ currency: 'USD', price: 96000 }] }],
    property_type: { id: 2 }, suite_amount: 0, room_amount: 2, bathroom_amount: 1,
    total_surface: 54, roofed_surface: 48, parking_lot_amount: 0,
    age: 0, floors_amount: 12, floor: 7,
    address: 'Don Bosco 10, Bernal', location: { name: 'Bernal' },
    geo_lat: -34.706, geo_long: -58.281,
    description: 'La continuidad de una serie real. Urban VII suma a un desarrollo entregado seis veces en la zona: 2 a 5 ambientes con balcón terraza y vistas al río. Esta unidad de 2 ambientes al frente recibe sol de la mañana y entrega en 24 meses. Apta crédito, con plan de pago directo del desarrollador.',
    photos: photos(['photo-1502672260266-1c1ef2d93688','photo-1416339306562-f3d12fefd36f','photo-1484154218962-a197022b5858','photo-1505693416388-ac5ce068fe85','photo-1486406146926-c627a92ad1ab']),
    tags: [{ name: 'En pozo' }, { name: 'Apto crédito' }, { name: 'Exclusiva' }],
    tags_objects: [{ name: 'Pileta' },{ name: 'SUM' },{ name: 'Gimnasio' },{ name: 'Seguridad 24h' },{ name: 'Cochera' },{ name: 'Baulera' },{ name: 'Ascensor' },{ name: 'Solárium' }],
    is_featured: true, development: { name: 'Urban VII', id: 'dev01' }
  },
  {
    id: 'p02', reference_code: 'AB-1987', web_price: true,
    title: 'Casa 4 ambientes con jardín y parrilla en Bernal Este',
    slug: 'casa-4amb-bernal-este-jardin',
    operations: [{ operation_type: '1', prices: [{ currency: 'USD', price: 189000 }] }],
    property_type: { id: 3 }, suite_amount: 1, room_amount: 4, bathroom_amount: 2,
    total_surface: 300, roofed_surface: 140, parking_lot_amount: 2, age: 18,
    address: 'Zapiola 1450, Bernal Este', location: { name: 'Bernal' },
    geo_lat: -34.711, geo_long: -58.273,
    description: 'Casa sólida en lote propio de 10 x 30. Tres dormitorios, living comedor con hogar, cocina independiente y un fondo verde con parrilla pensado para los domingos. A seis cuadras de la estación. Ideal familia que busca metros y tranquilidad.',
    photos: photos(['photo-1568605114967-8130f3a36994','photo-1564013799919-ab600027ffc6','photo-1522708323590-d24dbb6b0267','photo-1484154218962-a197022b5858','photo-1505693416388-ac5ce068fe85']),
    tags: [{ name: 'Apto crédito' }],
    tags_objects: [{ name: 'Jardín' },{ name: 'Parrilla' },{ name: 'Cochera' },{ name: 'Calefacción' }],
    is_featured: true
  },
  {
    id: 'p03', reference_code: 'AB-2102', web_price: true,
    title: 'PH 3 ambientes al frente con patio y terraza propia',
    slug: 'ph-3amb-don-bosco-patio',
    operations: [{ operation_type: '1', prices: [{ currency: 'USD', price: 124000 }] }],
    property_type: { id: 13 }, suite_amount: 0, room_amount: 3, bathroom_amount: 1,
    total_surface: 95, roofed_surface: 78, parking_lot_amount: 1, age: 12,
    address: 'Av. Espora 2233, Don Bosco', location: { name: 'Don Bosco' },
    geo_lat: -34.702, geo_long: -58.301,
    description: 'PH al frente sin expensas, con entrada independiente, patio delantero y terraza con parrilla. Dos dormitorios, baño completo y un espacio flexible que hoy funciona como escritorio.',
    photos: photos(['photo-1570129477492-45c003edd2be','photo-1522708323590-d24dbb6b0267','photo-1416339306562-f3d12fefd36f','photo-1505693416388-ac5ce068fe85']),
    tags: [{ name: 'Apto crédito' },{ name: 'Oportunidad' }],
    tags_objects: [{ name: 'Terraza' },{ name: 'Patio' },{ name: 'Cochera' },{ name: 'Parrilla' }],
    is_featured: true
  },
  {
    id: 'p04', reference_code: 'AB-1820', web_price: true,
    title: 'Monoambiente a estrenar, ideal renta en Quilmes Centro',
    slug: 'monoambiente-renta-quilmes-centro',
    operations: [{ operation_type: '1', prices: [{ currency: 'USD', price: 62000 }] }],
    property_type: { id: 2 }, suite_amount: 0, room_amount: 1, bathroom_amount: 1,
    total_surface: 34, roofed_surface: 32, parking_lot_amount: 0, age: 0, floor: 4,
    address: 'Rivadavia 540, Quilmes', location: { name: 'Quilmes' },
    geo_lat: -34.724, geo_long: -58.254,
    description: 'Monoambiente divisible a estrenar sobre Rivadavia. Renta estimada estable por demanda de estudiantes y profesionales. Edificio con SUM, laundry y seguridad. Entrega inmediata.',
    photos: photos(['photo-1522708323590-d24dbb6b0267','photo-1484154218962-a197022b5858','photo-1552321554-5fefe8c9ef14']),
    tags: [{ name: 'Apto crédito' }],
    tags_objects: [{ name: 'SUM' },{ name: 'Laundry' },{ name: 'Seguridad 24h' },{ name: 'Ascensor' }],
    is_featured: false
  },
  {
    id: 'p05', reference_code: 'AB-2210', web_price: true,
    title: '3 ambientes luminoso en alquiler, a una cuadra de la estación',
    slug: 'departamento-3amb-alquiler-bernal',
    operations: [{ operation_type: '2', prices: [{ currency: 'USD', price: 520 }] }],
    property_type: { id: 2 }, suite_amount: 0, room_amount: 3, bathroom_amount: 1,
    total_surface: 68, roofed_surface: 65, parking_lot_amount: 0, age: 9, floor: 3,
    address: '9 de Julio 320, Bernal', location: { name: 'Bernal' },
    geo_lat: -34.708, geo_long: -58.283,
    description: 'Tres ambientes al frente con balcón corrido, muy luminoso. Dos dormitorios, living comedor amplio y cocina con lavadero independiente. A una cuadra de la estación. Acepta mascotas.',
    photos: photos(['photo-1522708323590-d24dbb6b0267','photo-1505693416388-ac5ce068fe85','photo-1484154218962-a197022b5858','photo-1416339306562-f3d12fefd36f']),
    tags: [{ name: 'Acepta mascotas' }],
    tags_objects: [{ name: 'Balcón' },{ name: 'Ascensor' },{ name: 'Aire acondicionado' }],
    is_featured: false, expenses: 160
  },
  {
    id: 'p06', reference_code: 'AB-1755', web_price: true,
    title: 'Casa 5 ambientes con pileta y quincho en Wilde',
    slug: 'casa-5amb-pileta-wilde',
    operations: [{ operation_type: '1', prices: [{ currency: 'USD', price: 245000 }] }],
    property_type: { id: 3 }, suite_amount: 1, room_amount: 5, bathroom_amount: 3,
    total_surface: 420, roofed_surface: 210, parking_lot_amount: 3, age: 22,
    address: 'Las Flores 880, Wilde', location: { name: 'Wilde' },
    geo_lat: -34.703, geo_long: -58.318,
    description: 'Casa de categoría en lote de 12 x 35 con pileta, quincho cerrado con parrilla y galería. Planta baja con suite, planta alta con tres dormitorios. Garage para tres autos.',
    photos: photos(['photo-1568605114967-8130f3a36994','photo-1564013799919-ab600027ffc6','photo-1522708323590-d24dbb6b0267','photo-1505693416388-ac5ce068fe85','photo-1620626011761-996317b8d101']),
    tags: [{ name: 'Exclusiva' }],
    tags_objects: [{ name: 'Pileta' },{ name: 'Parrilla' },{ name: 'Jardín' },{ name: 'Cochera' }],
    is_featured: true
  },
  {
    id: 'p07', reference_code: 'AB-2055', web_price: true,
    title: 'Local a la calle sobre avenida, alta visibilidad',
    slug: 'local-comercial-avenida-bernal',
    operations: [{ operation_type: '2', prices: [{ currency: 'USD', price: 980 }] }],
    property_type: { id: 7 }, suite_amount: 0, room_amount: 1, bathroom_amount: 1,
    total_surface: 85, roofed_surface: 85, parking_lot_amount: 0, age: 25,
    address: 'Av. San Martín 1120, Bernal', location: { name: 'Bernal' },
    geo_lat: -34.709, geo_long: -58.286,
    description: 'Local a la calle de 85 m² con gran vidriera sobre San Martín. Salón principal, depósito y baño. Apto rubro gastronómico y comercial. Disponibilidad inmediata.',
    photos: photos(['photo-1441986300917-64674bd600d8','photo-1604719312566-8912e9227c6a']),
    tags: [],
    tags_objects: [{ name: 'Aire acondicionado' },{ name: 'Apto profesional' }],
    is_featured: false
  },
  {
    id: 'p08', reference_code: 'AB-2300', web_price: true,
    title: 'Galpón con entrepiso y oficina sobre lote propio',
    slug: 'galpon-deposito-quilmes-oeste',
    operations: [{ operation_type: '1', prices: [{ currency: 'USD', price: 210000 }] }],
    property_type: { id: 14 }, suite_amount: 0, room_amount: 0, bathroom_amount: 2,
    total_surface: 600, roofed_surface: 420, parking_lot_amount: 4, age: 20,
    address: 'Av. Calchaquí 3400, Quilmes Oeste', location: { name: 'Quilmes Oeste' },
    geo_lat: -34.748, geo_long: -58.268,
    description: 'Galpón de 420 m² cubiertos sobre lote de 600 m², con entrepiso, oficina administrativa, dos baños y portón de acceso para camiones. Sobre Av. Calchaquí, con excelente conectividad logística.',
    photos: photos(['photo-1441986300917-64674bd600d8','photo-1604719312566-8912e9227c6a']),
    tags: [{ name: 'Oportunidad' }],
    tags_objects: [{ name: 'Seguridad 24h' }],
    is_featured: false
  },
  {
    id: 'p09', reference_code: 'AB-1990', web_price: true,
    title: 'Lote apto multivivienda en zona de desarrollo',
    slug: 'terreno-lote-don-bosco',
    operations: [{ operation_type: '1', prices: [{ currency: 'USD', price: 135000 }] }],
    property_type: { id: 5 }, suite_amount: 0, room_amount: 0, bathroom_amount: 0,
    total_surface: 430, roofed_surface: 0, parking_lot_amount: 0, age: 0,
    address: 'Garibaldi 45, Don Bosco', location: { name: 'Don Bosco' },
    geo_lat: -34.701, geo_long: -58.300,
    description: 'Terreno de 10 x 43 (430 m²) con zonificación apta para multivivienda de baja altura. Sobre Garibaldi, en una zona en plena renovación a tres cuadras de la estación.',
    photos: photos(['photo-1500382017468-9049fed747ef','photo-1416879595882-3373a0480b5b']),
    tags: [{ name: 'Oportunidad' }],
    tags_objects: [],
    is_featured: false
  },
  {
    id: 'p10', reference_code: 'AB-2401', web_price: true,
    title: 'Monoambiente moderno, luminoso, a estrenar',
    slug: 'monoambiente-alquiler-quilmes-centro',
    operations: [{ operation_type: '2', prices: [{ currency: 'USD', price: 420 }] }],
    property_type: { id: 2 }, suite_amount: 0, room_amount: 1, bathroom_amount: 1,
    total_surface: 32, roofed_surface: 30, parking_lot_amount: 0, age: 0, floor: 3,
    address: 'Mitre 380, Quilmes', location: { name: 'Quilmes' },
    geo_lat: -34.724, geo_long: -58.256,
    description: 'Monoambiente divisible a estrenar en edificio nuevo sobre Mitre. Cocina americana, baño completo, piso flotante y excelente iluminación natural. Laundry y ascensor. Acepta mascotas.',
    photos: photos(['photo-1522708323590-d24dbb6b0267','photo-1484154218962-a197022b5858','photo-1552321554-5fefe8c9ef14']),
    tags: [{ name: 'Acepta mascotas' }],
    tags_objects: [{ name: 'Ascensor' },{ name: 'Laundry' },{ name: 'Seguridad 24h' }],
    is_featured: false, expenses: 90
  },
  {
    id: 'p11', reference_code: 'AB-2380', web_price: true,
    title: '2 ambientes amplio con cochera cubierta incluida',
    slug: '2amb-alquiler-don-bosco-familiar',
    operations: [{ operation_type: '2', prices: [{ currency: 'USD', price: 480 }] }],
    property_type: { id: 2 }, suite_amount: 0, room_amount: 2, bathroom_amount: 1,
    total_surface: 62, roofed_surface: 58, parking_lot_amount: 1, age: 10, floor: 2,
    address: 'Olazábal 1140, Don Bosco', location: { name: 'Don Bosco' },
    geo_lat: -34.703, geo_long: -58.302,
    description: 'Departamento de dos ambientes muy cuidado, al frente con buena iluminación. Cochera cubierta incluida. A tres cuadras de la estación de Don Bosco.',
    photos: photos(['photo-1522708323590-d24dbb6b0267','photo-1505693416388-ac5ce068fe85','photo-1416339306562-f3d12fefd36f']),
    tags: [],
    tags_objects: [{ name: 'Cochera' },{ name: 'Balcón' },{ name: 'Ascensor' }],
    is_featured: false, expenses: 130
  },
  {
    id: 'p12', reference_code: 'AB-2350', web_price: true,
    title: '3 ambientes al frente con gran balcón, pleno centro',
    slug: '3amb-alquiler-bernal-centro-balcon',
    operations: [{ operation_type: '2', prices: [{ currency: 'USD', price: 590 }] }],
    property_type: { id: 2 }, suite_amount: 0, room_amount: 3, bathroom_amount: 1,
    total_surface: 78, roofed_surface: 72, parking_lot_amount: 1, age: 14, floor: 5,
    address: '9 de Julio 520, Bernal', location: { name: 'Bernal' },
    geo_lat: -34.708, geo_long: -58.285,
    description: 'Tres ambientes en piso alto con balcón terraza y vistas abiertas. Dos dormitorios, living comedor con hogar y cocina independiente. Cochera y baulera incluidas.',
    photos: photos(['photo-1522708323590-d24dbb6b0267','photo-1416339306562-f3d12fefd36f','photo-1505693416388-ac5ce068fe85','photo-1484154218962-a197022b5858']),
    tags: [],
    tags_objects: [{ name: 'Balcón' },{ name: 'Cochera' },{ name: 'Ascensor' }],
    is_featured: true, expenses: 170
  },
  {
    id: 'p13', reference_code: 'AB-2320', web_price: true,
    title: 'Casa 3 ambientes con jardín y cochera en Wilde',
    slug: 'casa-alquiler-wilde-jardin',
    operations: [{ operation_type: '2', prices: [{ currency: 'USD', price: 680 }] }],
    property_type: { id: 3 }, suite_amount: 0, room_amount: 3, bathroom_amount: 1,
    total_surface: 200, roofed_surface: 85, parking_lot_amount: 1, age: 20,
    address: 'Rivadavia 2250, Wilde', location: { name: 'Wilde' },
    geo_lat: -34.706, geo_long: -58.322,
    description: 'Casa familiar en barrio residencial de Wilde. Dos dormitorios, living con acceso al jardín, cocina independiente y lavadero. Patio con parrilla y cochera. Acepta mascotas.',
    photos: photos(['photo-1568605114967-8130f3a36994','photo-1522708323590-d24dbb6b0267','photo-1505693416388-ac5ce068fe85']),
    tags: [{ name: 'Acepta mascotas' }],
    tags_objects: [{ name: 'Jardín' },{ name: 'Parrilla' },{ name: 'Cochera' }],
    is_featured: false
  },
  {
    id: 'p14', reference_code: 'AB-2290', web_price: true,
    title: 'PH 2 ambientes con patio propio y entrada independiente',
    slug: 'ph-alquiler-quilmes-patio-propio',
    operations: [{ operation_type: '2', prices: [{ currency: 'USD', price: 510 }] }],
    property_type: { id: 13 }, suite_amount: 0, room_amount: 2, bathroom_amount: 1,
    total_surface: 68, roofed_surface: 52, parking_lot_amount: 1, age: 18,
    address: 'Sarmiento 680, Quilmes', location: { name: 'Quilmes' },
    geo_lat: -34.725, geo_long: -58.258,
    description: 'PH en planta baja con entrada independiente, sin expensas, con patio exclusivo y parrilla. Un dormitorio, living comedor y cocina con lavadero. Cochera. Ideal para pareja o familia chica.',
    photos: photos(['photo-1568605114967-8130f3a36994','photo-1522708323590-d24dbb6b0267','photo-1552321554-5fefe8c9ef14']),
    tags: [{ name: 'Acepta mascotas' }],
    tags_objects: [{ name: 'Patio' },{ name: 'Parrilla' },{ name: 'Cochera' }],
    is_featured: false
  },
];

export const MOCK_AGENT = {
  name: 'Florencia Abriola',
  role: 'Fundadora · Martillera Matriculada',
  phone: '+54 11 6372-3335',
  whatsapp: '5491163723335',
  photo: 'abriola/florencia.png',
};
